import _ from 'lodash';

import Entity from './Entity';
import LineItemPayment from './LineItemPayment';
import Transaction from './Transaction';


const creditEntryTypes = [
  'PAYMENT', 'LANDLORD_COLLECTED', 'WRITE_OFF', 'ADJUSTMENT'
];
const debitEntryTypes = [
  'CHARGE', 'REVERSAL'
];
export const manualCreateLineItemEntryTypes = [
  'CHARGE'
];
export const manualAdjustmentLineItemEntryTypes = [
  'LANDLORD_COLLECTED', 'WRITE_OFF', 'ADJUSTMENT'
];

export const carryoverAdjustmentLineItemEntryTypes = [
  ...manualAdjustmentLineItemEntryTypes, 'POSITIVE_ADJUSTMENT'
];

const lineItemEntryEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'LineItemTypeEnum' }
};


export default class LineItemEntry {
  fields = {
    id: {
      value: null
    },
    line_item_id: {
      value: null
    },
    payment_id: {
      value: null
    },
    refund_id: {
      value: null
    },
    type: {
      value: null
    },
    amount: {
      value: null,
      valid: true
    },
    amount_tax_1: {
      value: null,
      valid: true
    },
    amount_tax_2: {
      value: null,
      valid: true
    },
    amount_tax_3: {
      value: null,
      valid: true
    },
    amount_tax_4: {
      value: null,
      valid: true
    },
    gross_amount: {
      value: null,
      valid: true
    },
    created_at: {
      value: null
    },
    line_item_payment: {
      value: null
    },
    line_item_reversal: {
      value: null
    },
    transaction: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const lineItemEntry = new this();

    for (let field in lineItemEntry.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'created_at':
            lineItemEntry.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          case 'line_item_payment':
            lineItemEntry.fields[field].value = (values[field] === null) ?
              values[field] :
              LineItemPayment.createFromQueryValues(values[field]);
            break;
          case 'line_item_reversal':
            lineItemEntry.fields[field].value = (values[field] === null) ?
              values[field] :
              LineItemPayment.createFromQueryValues(values[field]);
            break;
          case 'transaction':
            lineItemEntry.fields[field].value = (values[field] === null) ?
            values[field] :
            Transaction.createFromQueryValues(values[field]);
            break;
          default:
            lineItemEntry.fields[field].value = values[field];
        }
      }
    }

    return lineItemEntry;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      lineItemEntryEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(LineItemEntryInput);
    for (let field in values) {
      switch (field) {
        case 'amount':
        case 'amount_tax_1':
        case 'amount_tax_2':
        case 'amount_tax_3':
        case 'amount_tax_4':
          values[field] = (this.fields[field].value === null) ? 0 : this.fields[field].value;
          break;
        default:
          values[field] = this.fields[field].value;
      }
    }
    return values;
  }


  getGrossAmount() {
    const gross = this.fields.amount.value +
    this.fields.amount_tax_1.value +
    this.fields.amount_tax_2.value +
    this.fields.amount_tax_3.value +
    this.fields.amount_tax_4.value
    
    return (gross);
  }


  isCreditType() {
    return (creditEntryTypes.includes(this.fields.type.value));
  }


  isDebitType() {
    return (debitEntryTypes.includes(this.fields.type.value));
  }

  updateTransaction(transaction) {
    this.fields.transaction.value.update(transaction);
  }

  getTransactionQueryFields() {
    return this.fields.transaction.value ? [ this.fields.transaction.value.getQueryFieldValues() ] : [];
  }
}


export const LineItemEntryInput = {
  line_item_id: null,
  type: null,
  amount: null,
  amount_tax_1: null,
  amount_tax_2: null,
  amount_tax_3: null,
  amount_tax_4: null
}
